import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { HTMLAttributes } from "react";
import { HeaderTabType } from "../../types/ui-types";

type Props = {
  tab: HeaderTabType;
  notDraggable: boolean;
};

export default function MenuSortableItem({ tab, notDraggable }: Props) {
  const { isDragging, attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: tab.id,
    transition: {
      duration: 250, // milliseconds
      easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    },
  });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0 : 1,
    cursor: isDragging ? "grabbing" : "grab",
  };
  const dragAttributes = !notDraggable ? attributes : {};
  const dragListeners = !notDraggable ? listeners : {};

  return (
    <div
      key={tab.id}
      id={tab.id}
      ref={notDraggable ? null : setNodeRef}
      style={style}
      {...dragAttributes}
      {...dragListeners}
      className={`w-full blurred-light task rounded-xl h-14 gap-2 flex justify-center items-center ${
        isDragging ? "z-10 cursor-grabbing" : " "
      } `}>
      <img className="w-4" src={tab.iconSrc} alt="Drag Task" />

      <span className={`${isDragging ? "z-10 cursor-grabbing" : " "}`}>{tab.label}</span>
    </div>
  );
}

export type ItemProps = HTMLAttributes<HTMLDivElement> & {
  id: string;
  withOpacity?: boolean;
  isDragging?: boolean;
};
